<div class="position-relative image-box-container"
  [ngClass]="{ 'error': error }">


  <div *ngIf="useHeader" class="uploadImgHeader" ellipsis>
    {{ mediaTitle }}
  </div>
  <div
    class="dropbox {{viewOnlyMode? 'pointer-events-none' : 'pointer'}}"
    [ngClass]="{
      useHeaderBorderRadius: useHeader,
      useFooterBorderRadius: media.file_upload_id,
      error: error,
      dragging: isDragging
    }"
    (click)="( !useCustomAction ? hiddenInput.click() : customActionClicked() )"
    (dragover)="$event.preventDefault()"
    (dragenter)="!useCustomAction ? (isDragging = true) : null"
    (dragleave)="!useCustomAction ? (handleDragMove($event)) : null"
    (drop)="!useCustomAction ? handleDrop($event) : null"
  >
    <input
      #hiddenInput
      type="file"
      [hidden]="true"
      [accept]="filterFileInput()"
      (change)="handleFileInput($event)"
    />
    <div class="dropbox-guide">
      <img
        class="dropbox-guide-img"
        *ngIf="media.file_upload_id && !isVideo"
        [src]="getThumbnailUrl(media)"
        alt="Uploaded Image"
      />

      <!-- VIDEO CONTAINER -->
      <div class="video-container"
        *ngIf="media.file_upload_id && isVideo">
        <video
          #video
          [id]="media.file_upload_id.file_name"
          class="dropbox-guide-img"
          preload="metadata"
        >
          <source [src]="getThumbnailUrl(media)" />
          Your browser does not support HTML video.
          <track kind="subtitles" label="English" src="" srclang="en" default />
          <track kind="descriptions" label="Descriptions" src="" srclang="en" />
        </video>

        <!-- Hover overlay with arrow icon -->
        <div *ngIf="showVideoPlayButton" class="hover-overlay">
          <div class="arrow-icon">&#x25B6;</div>
        </div>
      </div>

      <span
        *ngIf="!media.file_upload_id"
        class="dropbox-guide-icon"
        [class.error]="error"
        inlineSVG="../../../../../assets/icons/Content/icon-upload-small.svg"
      ></span>
      <div *ngIf="!media.file_upload_id" class="dropbox-guide-text">
        <p class="m-0 px-4">
          {{
            promptText ??
            (isVideo ? "COMMON.CLICK_UPLOAD_VIDEO" : "COMMON.CLICK_UPLOAD_IMAGE")
              | translate
          }}
          <span *ngIf="promptText" class="text-uppercase">
            {{fileTypes}}
          </span>
        </p>
      </div>
      <div *ngIf="media.file_upload_id" class="dropbox-guide-filename">
        <p class="m-0 px-4" ellipsis>
          {{ isVideo ? "Video: " : "Image: " }} {{ media.file_upload_id.file_name }}
        </p>
      </div>

      <input
        *ngIf="isSelectable && media.file_upload_id"
        class="uploadFileCheckBox"
        type="checkbox"
        (click)="$event.stopPropagation()"
        [(ngModel)]="selected"
      />

      <div *ngIf="status" class="hover-top-right">
        <app-badge-status
          [autoContent]="true"
          [status]="status"
          [statusType]="MEDIA_STATUS">
        </app-badge-status>
      </div>
    </div>
  </div>

  <div *ngIf="media.file_upload_id && haveAction" class="uploadImgFooter">
    <app-icon-button
      title="See Preview"
      (click)="previewClicked()"
      extraClasses="text-primary"
      [iconOnly]="true"
      iconType="fa-regular"
      iconName="fa-eye"
      iconClass="text-primary"
      label=""
    ></app-icon-button>
    <app-icon-button
      title="Edit"
      (click)="!useCustomAction ? hiddenInput.click() : customActionClicked()"
      extraClasses="text-warning"
      [iconOnly]="true"
      iconType="fa-solid"
      iconName="fa-pencil"
      iconClass="text-warning"
      label=""
    ></app-icon-button>
    <app-icon-button
      title="Delete"
      (click)="deleteClicked()"
      extraClasses="text-danger"
      [iconOnly]="true"
      iconType="fa-regular"
      iconName="fa-trash-can"
      iconClass="text-danger"
      label=""
    ></app-icon-button>
    <app-icon-button
      *ngIf="isDownloadAvailable()"
      title="Download"
      (click)="downloadFile()"
      extraClasses="text-primary"
      [iconOnly]="true"
      iconType="fa-solid"
      iconName="fa-download"
      iconClass="text-primary"
      label=""
    ></app-icon-button>
  </div>

  <div *ngIf="error" class="uploadImgFooter error">
    {{ error | translate }}
  </div>

</div>
